<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatDayMonth } from '@/utils/format'

import BFeedbackPage from '@/components/base/BFeedbackPage/BFeedbackPage.vue'

// Feedback window of the respite dialog (ADA-4437 etapp 4), on the shared BFeedbackPage. The new
// due date is read from the CHOSEN date (the payload) — legacy showed it via an in-place mutation
// of document.next_flow_item, which is deliberately not ported (R14).
const { feedback, date } = defineProps<{
  feedback: 'success' | 'failed' | null
  date: Date | null
}>()

const emit = defineEmits<{ close: [] }>()

const { t } = useI18n()

const title = computed(() => (feedback != null ? t(`common.respite_${feedback}_title`) : ''))
// Figma: the chosen date renders as "14 juli" (day + month name) and bold inside the sentence —
// <i18n-t> component interpolation injects the styled span into the success text's {0} slot.
const formattedDate = computed(() => (date != null ? formatDayMonth(date) : ''))
</script>

<template>
  <b-feedback-page
    :feedback="feedback"
    :title="title"
    :button-text="t('common.return_to_case')"
    @close="emit('close')"
  >
    <i18n-t
      v-if="feedback === 'success'"
      keypath="common.respite_success_text"
      tag="span"
    >
      <span class="font-weight-bold">{{ formattedDate }}</span>
    </i18n-t>
    <template v-else-if="feedback === 'failed'">{{ t('common.respite_failed_text') }}</template>
  </b-feedback-page>
</template>
